import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {NavigationLink} from './navigation-link';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ProductDetailsNavigationLinkService {

  private navigationLinks: NavigationLink[] = [];
  private eventStream: BehaviorSubject<NavigationLink[]>;

  constructor(@Inject(PLATFORM_ID) public platformId: object) {
    this.eventStream = new BehaviorSubject(this.navigationLinks);
  }

  public getNavigationLinks$(): Observable<NavigationLink[]> {
    return this.eventStream.asObservable();
  }

  public addNavigationLink(navLink: NavigationLink): void {
    if (!this.navigationLinks.find(elem => elem.headline === navLink.headline && elem.id === navLink.id)) {
      this.navigationLinks.push(navLink);
      this.sortByOffset();
    }
  }

  public removeNavigationLink(navLink: NavigationLink): void {
    this.navigationLinks = this.navigationLinks.filter(value => value.headline !== navLink.headline || value.id !== navLink.id);
    this.eventStream.next(this.navigationLinks);
  }

  public sortByOffset(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.navigationLinks.sort((firstEl, secondEl) => {
        const firstElement: HTMLElement = document.getElementById(firstEl.id);
        const secondElement: HTMLElement = document.getElementById(secondEl.id);
        if (!!firstElement && !!secondElement) {
          const firstElOffset: number = firstElement.offsetTop;
          const secondElOffset: number = secondElement.offsetTop;
          return firstElOffset - secondElOffset;
        } else {
          if (firstElement) {
            return -1;
          }
          if (secondElement) {
            return 1;
          }
        }
      });
      this.eventStream.next(this.navigationLinks);
    }
  }
}
